import React from 'react';
import { Col } from 'antd';

import SuiteEnum from 'redpoints-model-js-common/enumeration/SuiteEnum';

import { IconContainer } from 'redpoints-front-components/index';
import { InfoBoxAsync, Notification } from 'redpoints-front-components/index';
import {
  getPermission,
  historyHelper,
  routeBuilder,
} from 'redpoints-front-common/helpers';
import { INFRINGEMENT_CONFIRMATION_PATHS } from 'redpoints-front-infringement-confirmation/common/config/constants';

import { translate } from '../../../helpers/languageHelper';

export const withColumn = (
  children,
  key,
  className,
  overridedProps,
  colStyle
) => (
  <Col
    sm={24}
    md={12}
    lg={6}
    {...overridedProps}
    style={{ marginBottom: 15, ...colStyle }}
    className={className}
    key={key}
  >
    {children}
  </Col>
);

export const withColumnCopyright = (children, key, className, colStyle) =>
  withColumn(children, key, className, { lg: 6 }, colStyle);

export const withColumnPiracy = (children, key, className) =>
  withColumn(children, key, className, { lg: 6 });

export const generateInfoBoxLoader = (
  { color, text, icon, number, clickHandler, className },
  promise,
  translation
) => (
  <InfoBoxAsync
    infoBoxProps={{
      color: color,
      text: translate(`${translation}.${text}`),
      imageNode: icon,
      number: number,
      clickHandler: clickHandler,
      className,
    }}
    promiseFn={promise}
    onError={() => {
      Notification.error({
        description: translate(`${translation}.info_box_error`),
      });
    }}
  />
);

const PENDING_CONFIRMATION_QS = 'incidentStatus=PENDING_CONFIRMATION';
const PENDING_REASSESSMENT_QS = 'incidentStatus=PENDING_REASSESSMENT';

const redirectionMap = Object.freeze({
  pending: {
    name: translate('infringement_confirmation.title'),
    path: `${INFRINGEMENT_CONFIRMATION_PATHS.INFRINGEMENT_CONFIRMATION}?${PENDING_CONFIRMATION_QS}`,
  },
  pendingReassessment: {
    name: translate('infringement_confirmation.title'),
    path: `${INFRINGEMENT_CONFIRMATION_PATHS.INFRINGEMENT_CONFIRMATION}?${PENDING_REASSESSMENT_QS}`,
  },
  critical: [
    {
      name: translate('reporting.allIncidentsInternal.title'),
      path: 'reporting/all-incidents?special=critical',
      entity: 'frontoffice_reporting_allincidents',
    },
    {
      name: translate('reporting.allIncidentsCustomer.title'),
      path: 'reporting/all-incidents-customer?special=critical',
      entity: 'frontoffice_reporting_allincidents_customerview',
    },
  ],
  bookmarks: [
    {
      name: translate('reporting.allIncidentsInternal.title'),
      path: 'reporting/all-incidents?special=bookmark',
      entity: 'frontoffice_reporting_allincidents',
    },
    {
      name: translate('reporting.allIncidentsCustomer.title'),
      path: 'reporting/all-incidents-customer?special=bookmark',
      entity: 'frontoffice_reporting_allincidents_customerview',
    },
  ],
});

export const goTo = async (context, type) => {
  let redirectionHelper = redirectionMap[type];
  const checkPermissions = async entityName =>
    await getPermission({ context, entity: entityName, suite: SuiteEnum.IPR });

  if (Array.isArray(redirectionHelper)) {
    const results = await Promise.all(
      redirectionHelper.map(elem => checkPermissions(elem.entity))
    );
    const index = results.indexOf(true);
    redirectionHelper = redirectionMap[type][index >= 0 ? index : 0].path;
  } else {
    redirectionHelper = redirectionMap[type].path;
  }
  const link = routeBuilder(context, redirectionHelper);
  historyHelper.push(link);
};

export const generateHomeIcon = name => (
  <IconContainer
    iconName={React.createElement(name)}
    iconStyle={{
      fontSize: 35,
      color: 'white',
    }}
  />
);

export const getIncidentStatusesFromGroups = groups => {
  if (Array.isArray(groups)) {
    return groups.reduce((incidentStatusList, { incidentStatuses } = {}) => {
      if (Array.isArray(incidentStatuses)) {
        return incidentStatusList.concat(incidentStatuses);
      }
      return incidentStatusList;
    }, []);
  }

  return null;
};
